export const EDIT_ROUTES = {
  colors: {
    name: 'cor'
  },
  doors: {
    name: 'portas'
  },
  gear: {
    name: 'cambio'
  },
  fuel: {
    name: 'combustivel'
  },
  km: {
    name: 'quilometragem'
  },
  price: {
    name: 'preco'
  },
  optionals: {
    name: 'opcionais'
  },
  differentials: {
    name: 'diferenciais'
  },
  description: {
    name: 'descricao'
  },
  photos: {
    name: 'fotos'
  },
  version: {
    name: 'versao'
  },
  fabricationYear: {
    name: 'anofabricacao'
  },
  modelYear: {
    name: 'anomodelo'
  },
  chassi: {
    name: 'chassi'
  }
};
